import { CookingPot, Wheat, UtensilsCrossed, Flame, Sparkle, Sunrise, ArrowRight } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/Reveal";
import { wa, WA_MESSAGES, IMG } from "@/lib/site";

const CARDS = [
  { icon: CookingPot, title: "Everyday Cooking", image: IMG.cuisine, large: true },
  { icon: Wheat, title: "Dal & Rice" },
  { icon: UtensilsCrossed, title: "Rotis & Parathas", image: IMG.texture, large: true },
  { icon: Flame, title: "Traditional Indian Recipes" },
  { icon: Sparkle, title: "Festive Cooking" },
  { icon: Sunrise, title: "Daily Food Rituals" },
];

export default function Usage() {
  return (
    <section id="usage" data-testid="usage-section" className="bg-ivory py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-5 md:px-10">
        <SectionHeading eyebrow="In Your Kitchen" title="How to Use MAHIRA Ghee" />
        <div className="mt-16 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {CARDS.map((c, i) => (
            <Reveal key={c.title} delay={(i % 4) * 0.07} className={c.large ? "sm:col-span-2" : ""}>
              <div
                data-testid={`usage-card-${c.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                className="group relative h-full min-h-[220px] overflow-hidden rounded-3xl border border-forest/10 bg-white/60 p-7 transition-[transform,box-shadow,border-color] duration-500 hover:-translate-y-1.5 hover:border-gold/40 hover:shadow-[0_30px_60px_-25px_rgba(26,54,38,0.25)]"
              >
                {c.image && (
                  <>
                    <img
                      src={c.image}
                      alt={c.title}
                      loading="lazy"
                      className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-forest/55 transition-[background-color] duration-500 group-hover:bg-forest/45" />
                  </>
                )}
                <div className="relative flex h-full flex-col justify-between gap-10">
                  <span
                    className={`inline-flex h-11 w-11 items-center justify-center rounded-full ${
                      c.image ? "bg-ivory/15 text-gold-light backdrop-blur-sm" : "bg-gold-light/50 text-forest"
                    }`}
                  >
                    <c.icon className="h-5 w-5" />
                  </span>
                  <h3
                    className={`font-heading text-2xl md:text-3xl ${
                      c.image ? "text-ivory" : "text-forest"
                    }`}
                  >
                    {c.title}
                  </h3>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.15}>
          <div className="mt-14">
            <a
              data-testid="usage-cta"
              href={wa(WA_MESSAGES.order())}
              target="_blank"
              rel="noreferrer"
              className="group inline-flex items-center gap-3 rounded-full bg-forest px-8 py-4 text-[12px] font-semibold uppercase tracking-[0.18em] text-ivory transition-[background-color,transform] duration-300 hover:-translate-y-1 hover:bg-forest-light"
            >
              Get MAHIRA for Your Home
              <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
